(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3561],{

/***/ 46161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/reposh-poshmark/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Poshmark",
      title: "How-To Guide in Poshmark Reselling",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\"Poshmark is a mobile app that allows users to buy and sell items online. In this post, we provide a how-to guide for the most common features of the app. We also offer step-by-step instructions on how to use the app for sellers.\""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With the holidays coming up this is a great time for sellers to improve their game to improve their visibility and get noticed by potential buyers and kickstart their sales just in time for the new year. You may have heard of Poshmark because like similar platforms such as eBay, ThredUp, Tradesy, and Mercari it is an online marketplace to buy and sell a wide array of items from preloved clothing to the newest items from specific brands."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you\u2019re looking into becoming a Poshmark seller, then this is your beginner\u2019s guide to all the basics and some helpful tips and secrets that you need to know to sell on Poshmark.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Is Poshmark reliable?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Before you venture into joining any new platform it is important to do your research and one of the most common questions before starting anything new should be determining how reliable and legit it is. Poshmark is a trusted platform to buy and sell with millions of active users onboard and a diverse range of sellers that make their living off Poshmark as their full-time job not just as a side gig."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["For new Posh sellers on the block, you can rest assured that you have protection from buyer fraud as long as you disclose everything on your post or listing through authentic and well-captured quality photos of the items and as well as a detailed description of the item. These two will prevent a buyer from making a return unless you allow it.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["However, you should also take note that you can\u2019t list an item under false advertising because the buyer has 3 days to bring up their order concerns to Poshmark. And you will not get paid unless the buyer accepts the Poshmark item or if they have passed the 3-day mark without reporting any issues with their purchase.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As a seller, it is expected of you that you don\u2019t participate in fraudulent acts such as selling a fake item or wrongfully advertising your listings on purpose with the purpose to deceive buyers. These acts can get you suspended or banned from the platform to avoid Poshmark scams."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Buying on Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you\u2019ve ever bought something from Poshmark and found out that it\u2019s not exactly what you had in mind then it would be incredibly disappointing. However, you can always turn things around by making use of this merchandise by reselling it to recoup at least some of your costs."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Reposh"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The good news is that Poshmark has rolled out a Reposh button on purchases. What it is is essentially reselling an item that you bought on Poshmark on Poshmark again. All you have to do is simply click on the button and it automatically populates the data fields with all the information that the previous seller has already put in.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "According to Poshmark, this reposhing cycle is intended to help create a more sustainable future for our environment by extending the life cycle of an item."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How do bundles work?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Bundles are great because bundling your items allows you to save on shipping costs for multiple items and get a discount. Most sellers offer a percentage when buying multiple items from their closet or store. This is great when you have a lot of old or excess inventory that you want to get rid of to make way for new stock. You can even offer additional promotions or bundle discounts such as discounted shipping fees or even consider free shipping."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How much does it cost to sell on Poshmark?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Unlike other platforms such as Amazon or eBay, it does not cost anything to sell on Poshmark. In fact, once you sell an item, Poshmark will take a 20% fee for sales over $12 and $9.25 for sales under $12."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to sell on Poshmark?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It\u2019s easy to get started selling on Poshmark, all you have to do is download the Poshmark app and create an account then you can start listing by taking clear quality pictures by clicking on the small camera icon on the app. Simply enter the details of what you are selling, make sure it is informative, and disclose all relevant information for the future buyer."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How does Poshmark shipping work?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Poshmark makes it very easy to ship once your item sells. You do not have to pay for anything at the post office. All you have to do is simply follow these steps."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Once your item has sold, print out the shipping label that will be sent to your email. "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Place your item in a polybag or box. You can reuse old packaging from an amazon order or any other reusable packaging. If you do not have any, you can use the USPS envelopes or boxes that you will find at your local USPS store, which are free for you to use. Just skip the ones that say \u201CExpress\u201D.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tape your shipping label, removing or covering all previous labels."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Drop off at your local USPS drop box or counter. And it\u2019s good practice to ask for a receipt. Poshmark\u2019s labels are good for up to 5 pounds. If you are shipping an item above 5 pounds and you are not able to fit them inside any of USPS\u2019s flat rate boxes, you will have to pay an overweight fee."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This may be a lot of information to take in but it\u2019ll be the basics once you get started. However to excel at selling it takes focus and great dedication of time to navigate through all the demanding daily tasks such as relisting, sharing, updating your closet, and much more. So if you\u2019re just starting out or need to learn the tricks of the trade to get repeat customers, OneShop is a great software to get you started and achieve your ambition for your business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With its easy-to-use interface and readily customizable tools so without worry you can leave the manual but valuable time-consuming tasks like bulk listing actions behind so you can free up more spare time to focus on more important things to grow your business like upgrading your digital presence to Facebook and Instagram. OneShop also functions as your virtual assistant that works 24/7 to improve your reach by automating shares, follows, and more!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Try it for yourself, register for free, and enjoy a 7-day trial with no commitment or credit card required."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/reposh-poshmark.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "How-To Guide in Poshmark Reselling"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Poshmark is a mobile app that allows users to buy and sell items online. In this post, we provide a how-to guide for the most common features of the app. We also offer step-by-step instructions on how to use the app for sellers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/reposh-poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/reposh-poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "How-To Guide in Poshmark Reselling"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Poshmark is a mobile app that allows users to buy and sell items online. In this post, we provide a how-to guide for the most common features of the app. We also offer step-by-step instructions on how to use the app for sellers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 2132:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/reposh-poshmark",
      function () {
        return __webpack_require__(46161);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(2132); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);